import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateIndividualDTO } from "./type";
import type { Individual } from "@typings/entities/individuals";

export async function createIndividual(
  individual: CreateIndividualDTO,
): Promise<Individual> {
  const response = await apiClient.post<Individual>(
    apiPaths.individuals.create,
    individual,
  );
  return response.data;
}
